export default __webpack_public_path__ + "static/media/logo_set_50.45f97349.png";